import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const myAccountAPI = createApi({
    reducerPath: "myAccountAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");
            headers.set("Content-Type", "application/json");
            return headers;
        },
    }),
    endpoints: (builder) => ({
        submitRefreshToken: builder.mutation({
            query: (formData) => ({
                url: "admin/refresh",
                method: "POST",
                body: formData,
            }),
        }),

        logout: builder.mutation({
            query: (formData) => ({
              url: "admin/logout",
              method: "POST",
              body: formData,
            }),
          }),

          

    }),
});

export const { useSubmitRefreshTokenMutation, useLogoutMutation } = myAccountAPI;
